import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

// The plan/custom-amount radios, the totals and the hidden prepayment_plan_id/custom-amount
// fields all live in a different panel of subdomain/accounts/prepayments/index.html.haml. No
// ancestor wraps both panels without wrapping the whole page, so these stay id lookups rather
// than targets.
const REQUIRED_FIELDS = ["prepayment_plan_id", "name", "line1", "city", "state", "postal_code"];
const PREFILL_FIELDS = ["name", "email", "line1", "line2", "city", "state", "postal_code"];

export default class extends Controller {
  static get targets() { return ["form", "submitButton", "creditsTotal", "cashTotal"]; }

  static get values() {
    return {
      url: String,
      planFieldId: String,
      customAmountFieldId: String,
      customRadioId: String,
      pageCreditsTotalId: String,
      pageCashTotalId: String
    };
  }

  connect() {
    $(this.element).on("shown.bs.modal.creditInvoice", () => this.onShown());

    this.keyupListener = () => this.refreshSubmit();
    this.formTarget.querySelectorAll("input").forEach((input) => {
      input.addEventListener("keyup", this.keyupListener);
    });

    this.prefillFromStripe();
  }

  disconnect() {
    $(this.element).off("shown.bs.modal.creditInvoice");
    this.formTarget.querySelectorAll("input").forEach((input) => {
      input.removeEventListener("keyup", this.keyupListener);
    });
  }

  onShown() {
    const creditsText = document.getElementById(this.pageCreditsTotalIdValue).textContent;
    const cashText = document.getElementById(this.pageCashTotalIdValue).textContent;
    this.creditsTotalTarget.textContent = `${creditsText} LT Credits`;
    this.cashTotalTarget.textContent = cashText;

    const planId = document.getElementById(this.planFieldIdValue).value;
    const customAmount = document.getElementById(this.customAmountFieldIdValue).value;
    this.formTarget.querySelector("#invoice_prepayment_plan_id").value = planId;
    this.formTarget.querySelector("#invoice_prepayment_custom_amount").value = customAmount;

    this.refreshSubmit();
  }

  refreshSubmit() {
    this.submitButtonTarget.classList.add("btn-disabled");

    const missing = REQUIRED_FIELDS.some((field) => {
      return !this.formTarget.querySelector(`#invoice_${field}`).value;
    });
    const isCustom = document.getElementById(this.customRadioIdValue).checked;
    const customAmount = document.getElementById(this.customAmountFieldIdValue).value;

    if (!missing && (!isCustom || parseInt(customAmount, 10) >= 1)) {
      this.submitButtonTarget.classList.remove("btn-disabled");
    }
  }

  submit(event) {
    event.preventDefault();
    // btn-disabled is only a class on a link, so it doesn't stop the click by itself
    if (this.submitButtonTarget.classList.contains("btn-disabled")) { return; }
    // Not formTarget.submit(): jQuery runs the form's own submit handlers first, the native call
    // skips them.
    $(this.formTarget).submit();
  }

  prefillFromStripe() {
    if (!this.urlValue) { return; }

    const options = RequestHelper.defaultRequestOptions();
    options.headers = Object.assign({}, options.headers, {
      "X-Requested-With": "XMLHttpRequest",
      "Accept": "application/json, text/plain, */*"
    });

    fetch(this.urlValue, options).
      then((response) => {
        if (!response.ok) { throw new Error(response.statusText); }
        return response.json();
      }).
      then((data) => {
        PREFILL_FIELDS.forEach((field) => {
          if (!data[field]) { return; }

          const el = this.formTarget.querySelector(`#invoice_${field}`);
          if (!el) { return; }

          if (el.matches("input, select")) {
            el.value = data[field];
          } else {
            el.textContent = data[field];
          }
          el.dispatchEvent(new Event("change"));
        });
      }).
      catch((error) => {
        console.warn(error);
        Honeybadger.notify(error);
      });
  }
}
